<script setup lang="ts">
import { restoreAppConfirmFocus, useAppConfirmController } from '@/composables/useAppConfirm'

const { t } = useI18n()
const { request, resolve } = useAppConfirmController()

const isOpen = computed({
  get: () => request.value !== null,
  set: (open: boolean) => {
    if (!open) {
      resolve(false)
    }
  },
})
</script>

<template>
  <UModal
    v-model:open="isOpen"
    :title="request?.title"
    :description="request?.message"
    :dismissible="request?.dismissible !== false"
    :close="request?.dismissible === false ? false : undefined"
    :ui="{ overlay: 'z-[60]', content: 'z-[60]' }"
    @after:leave="restoreAppConfirmFocus"
  >
    <template #footer>
      <div class="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <UButton
          v-if="request?.showCancel !== false"
          :label="request?.cancelLabel || t('common.actions.cancel')"
          color="neutral"
          variant="outline"
          @click="resolve(false)"
        />
        <UButton
          :label="request?.confirmLabel || t('common.labels.ok')"
          :color="request?.confirmColor || 'primary'"
          :icon="request?.confirmIcon"
          @click="resolve(true)"
        />
      </div>
    </template>
  </UModal>
</template>
